
import { returnPaginationRange } from "../Utils/appUtils";

import React, { useState, useEffect } from 'react';


function PaginationCustom(prop) {
  // Initialize state with the range array
  const [paginationArray, setPaginationArray] = useState(() => 
    returnPaginationRange(prop.totalPages, prop.page, prop.limit, prop.siblings)
  );

  // Update the pagination array whenever these props change
  useEffect(() => {
    setPaginationArray(returnPaginationRange(prop.totalPages, prop.page, prop.limit, prop.siblings));
  }, [prop.totalPages, prop.page, prop.limit, prop.siblings]);

  return (
    <div className="container my-3">
      <ul className="pagination pagination-md justify-content-end my-3">
        <li className="page-item">
          <span className="page-link" onClick={() => prop.onPageChange("&laquo;")}>&laquo;</span>
        </li>
        <li className="page-item">
          <span  className="page-link" onClick={() => prop.onPageChange("&lsaquo;")}>&lsaquo;</span>
        </li>
        {paginationArray.map((value, index) => (
          <li
            className={`page-item ${value === prop.page && value !== "..." ? "active disabled btn-primary bg-primary" : ""}`}
            key={value === "..." ? `ellipsis-${index}` : value}
          >
            <span className="page-link" onClick={() => prop.onPageChange(value)   }>
              {value}
            </span>
          </li>
        ))}
        <li className="page-item">
          <span className="page-link" onClick={() => prop.onPageChange("&rsaquo;")}>&rsaquo;</span>
        </li>
        <li className="page-item">
          <span className="page-link" onClick={() => prop.onPageChange("&raquo;")}>&raquo;</span>
        </li>
      </ul>
    </div>
  );
}

export default PaginationCustom;





